import React from 'react'
import { Grid, Box, Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { MutualLogo } from '~/assets/icons'
import { StepIndicator, ResponsiveStepIndicator, SecondPageLayout } from './components'
import { useIsMobileScreen } from '~/hooks'

export type FeedbackPageLayoutProps = {
  title: string,
  description: string | JSX.Element
}

const useStyles = makeStyles({
  container: {
    height: '100vh'
  },
  firstHalf: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: mutualTheme.spacing(4),
    backgroundColor: mutualTheme.palette.common.white
  },
  secondHalf: {
    flex: 1,
    display: 'flex',
    paddingLeft: mutualTheme.spacing(4),
    backgroundColor: mutualTheme.palette.grey[100],
    [mutualTheme.breakpoints.down('lg')]: {
      margin: 0,
      padding: 0,
      flexDirection: 'column'
    }
  },
  circledText: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: mutualTheme.spacing(5)
  },
  iconContainer: {
    flexGrow: 1,
    justifyContent: 'flex-start'
  },
  subTitleText: {
    marginTop: 32,
    marginLeft: 80,
    color: mutualTheme.palette.textGray2.main
  },
  stepsContainer: {
    width: 270,
    flexGrow: 2
  }
})

export const FeedbackPageLayout: React.FC<FeedbackPageLayoutProps> = (props) => {
  const { children, title, description } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Grid className={classes.container} container>
      <Hidden mdDown>
        <Grid className={classes.firstHalf} xs={isMobile ? undefined : 4} item>
          <Box className={classes.iconContainer}>
            <MutualLogo />
          </Box>
          <Box className={classes.stepsContainer}>
            <StepIndicator />
          </Box>
        </Grid>
      </Hidden>
      <Grid className={classes.secondHalf} xs={isMobile ? 12 : 8} item>
        <Hidden mdUp>
          <ResponsiveStepIndicator />
        </Hidden>
        <SecondPageLayout
          title={title}
          description={description}
        >
          {children}
        </SecondPageLayout>
      </Grid>
    </Grid>
  )
}
